import { render, staticRenderFns } from "./ChannelMix.vue?vue&type=template&id=7b71b3e8&scoped=true"
import script from "./ChannelMix.vue?vue&type=script&lang=js"
export * from "./ChannelMix.vue?vue&type=script&lang=js"
import style0 from "./ChannelMix.vue?vue&type=style&index=0&id=7b71b3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71b3e8",
  null
  
)

export default component.exports